var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfektschutzSmall = function SvgInfektschutzSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infektschutz-small_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "infektschutz-small_svg__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 0H0v32h32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90BA1E",
    mask: "url(#infektschutz-small_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.541 18.194c-2.564.248-5.818-.76-5.851-.77l-.4 1.271c.126.04 2.8.872 5.382.872q.505.001.998-.046c2.845-.276 4.813-1.03 4.895-1.063l-.482-1.243c-.02.007-1.89.723-4.542.979M21.278 15.848l-.053-1.332c-.04 0-4.036.16-5.25.16-3.191 0-5.489-.158-5.511-.16l-.093 1.331c.023.001 2.363.162 5.604.162 1.24 0 5.138-.155 5.303-.161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.004 9.451a16 16 0 0 1-.022-.658c0-.885-.498-1.257-.964-1.31-1.143-.137-2.757 1.737-3.474 3.934-1.305-.367-4.337-1.122-7.206-1.122-3.073 0-6.688.621-8.047.878C7.556 9.45 6.163 7.267 4.92 7.46c-.262.043-.873.257-.904 1.313q-.007.243-.024.569c-.113 2.308-.37 7.683 3.51 10.635.436.607 3.273 4.275 8.415 4.688q.22.017.438.017c4.234 0 8.009-4.802 8.172-5.013l.133-.172v-.01q.256-.355.51-.698c.83-1.12 1.612-2.179 2.146-3.513.848-2.122.748-4.44.688-5.826m-22.68-.043.02-.431c.478.432 1.268 1.524 1.851 3.044-.056.489-.205 1.92-.16 3.16.021.554.1 1.695.17 2.676-2.161-2.625-1.978-6.464-1.881-8.449m18.017 9.607c-.698.836-4.018 4.598-7.318 4.321-4.312-.345-6.858-3.376-7.374-4.051-.055-.716-.248-3.266-.281-4.153-.035-.935.056-2.027.118-2.638 1.274-.24 4.884-.865 7.852-.865 2.85 0 5.99.826 7.07 1.137.065.505.149 1.498.061 2.876-.041.663-.106 2.688-.128 3.373m2.736-4.233c-.336.842-.811 1.59-1.338 2.332a67 67 0 0 1 .061-1.388c.116-1.831-.045-3.03-.116-3.447.434-1.742 1.434-2.952 1.967-3.34q.006.246.02.57c.056 1.278.149 3.417-.594 5.273"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infektschutz-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgInfektschutzSmall;